import { Stack, Typography, useTheme } from '@mui/material'
import { DriverContainer, DriverName } from 'components/selected-driver/selected-driver.styles'

interface SelectedCarrierProps {
  carrierName?: string
}

const SelectedCarrier = ({ carrierName }: SelectedCarrierProps) => {
  const theme = useTheme()

  if (!carrierName?.trim()) {
    return null
  }

  return (
    <Stack direction="row" spacing={4}>
      <DriverContainer direction="row" spacing={1}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          Carrier Name
        </Typography>
        <DriverName theme={theme}>{carrierName}</DriverName>
      </DriverContainer>
    </Stack>
  )
}

export default SelectedCarrier
